import type { ConceptDef } from '../types';

export const intraverbalOpposites: ConceptDef = {
  kind: 'tileMatch',
  id: 'intraverbal-opposites',
  label: 'Intraverbal Opposites',
  category: 'Intraverbal',
  description: 'Hear a word; tap its opposite.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'Opposite of hot.', answer: '❄ cold' },
      { say: 'Opposite of big.', answer: '🤏 small' },
      { say: 'Opposite of fast.', answer: '🐢 slow' },
      { say: 'Opposite of up.', answer: '⬇ down' },
      { say: 'Opposite of happy.', answer: '😢 sad' },
      { say: 'Opposite of day.', answer: '🌙 night' },
    ],
  },
};
